import { Box, Typography, makeStyles } from "@material-ui/core";

import { ITheme } from "../constants/theme";
import { AdminInvoiceItem } from './AdminInvoiceItem';
import { InvoiceItem } from "./InvoiceItem";

interface IProps {
  data: any;
  onCheckboxChange: (data, value) => void;
  isAdmin?: boolean;
  selectedItems?: string[];
}
export const InvoiceGroupItem = ({ data, onCheckboxChange, isAdmin, selectedItems }: IProps) => {
  const classes = useStyles();

  const GroupItem = () => {
    return (
      <div className={classes.groupContainer}>
        <div className={classes.groupNameContainer}>
          <Typography
            variant="subtitle2"
            component="legend"
            color="textPrimary"
          >
            {data.OrderNo}
          </Typography>
        </div>
        {data.Invoices.map((item, index) => {
          if (isAdmin) {
            return (
              <AdminInvoiceItem key={index} data={item} onCheckboxChange={onCheckboxChange} selectedItems={selectedItems as string[]} />
            );
          }
          return (
            <InvoiceItem key={index} data={item} onCheckboxChange={onCheckboxChange} />
          );
        })}
      </div>
    );
  };

  return (
    <Box data-order="order-item" className={classes.container}>
      <GroupItem />
    </Box>
  );
};
const useStyles = makeStyles((theme: ITheme) => ({
  container: {
    marginBottom: "24px",
  },

  gridMargin: {
    marginTop: "5px",
  },
  groupContainer: {},
  groupNameContainer: {
    paddingLeft: 24,
    paddingBottom: 24,
    paddingTop: 24,
  },
}));
